import queries from "../helpers/caseQueries";
import userQueries from "../helpers/queries";
import Modal from "../Components/modal";
import { useApolloClient } from "@apollo/react-hooks";
import React, { useState, useMemo, useEffect, useCallback } from "react";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { FiEdit, FiUnlock, FiEdit2, FiTrash2, FiPlus } from "react-icons/fi";
import AsyncSelect from "react-select/async";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { withUser } from "../Contexts/user";
import { useSidebar } from "../Contexts/sidebar";


let timerId;

const capitalizeWords = str => {
    return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
};


const statusOptions = [
    {
        label: "All",
        value: "all",
    },
    {
        label: "Active",
        value: "active",
    },
    {
        label: "Inactive",
        value: "inactive",
    },
];

const Projects = ({ user }) => {
    const { isDarkMode } = useSidebar();
    const [modalData, setModalData] = useState({});
    const [createModalState, setCreateModalState] = useState(false);
        const [editModalState, setEditModalState] = useState(false);

        const [paginationState, setPaginationState] = useState({
            limit: 30,
            page: 1,
            dir: "desc",
            by: "_id",
        });
        const apollo = useApolloClient();

    const initialFilters = useMemo(
        () => ({
            name: undefined,
            code: undefined,
            status: "active",
            ranking: undefined,
            type: undefined,
            memberclub: undefined,
            state: undefined,
            risk: undefined,
            dateFrom: undefined,
            dateTo: undefined,
            projectDirector: undefined,
            salesDirector: undefined,
            propertyAgent: undefined,
            project: undefined,
            developer: undefined,
        }),
        []
    );
    const [filters, setFilters] = useState(initialFilters);

    const [debouncedFilters, setDebouncedFilters] = useState({
        developer: "",
    });

    const initialAppliedSearchVariables = useMemo(
        () => ({
            name: undefined,
            projectDirector: undefined,
            salesDirector: undefined,
            propertyAgent: undefined,
            status: "active",
            project: null,
            developer: "",
        }),
        []
    );
    const [appliedSearchVariables, setAppliedSearchVariables] = useState(
        initialAppliedSearchVariables
    );

    const handleSearch = () => {
        setAppliedSearchVariables({
            name: filters.name,
            projectDirector: filters.projectDirector,
            salesDirector: filters.salesDirector,
            propertyAgent: filters.propertyAgent,
            status: filters.status === "all" ? undefined : filters.status,
            project: filters.project ? filters.project.value : null,
            developer: filters.developer ?? "",
        });
        setPaginationState(prev => ({ ...prev, page: 1 }));
    };

    const [formKey, setFormKey] = useState(0);

    const {
        register,
        errors,
        handleSubmit,
        control,
        setValue,
        reset: resetForm,
    } = useForm({
        defaultValues: {
            name: "",
            projectDirector: undefined,
            salesDirector: undefined,
        },
    });

    useEffect(() => {
        if (editModalState) {
            const {
                name,
                projectDirector,
                salesDirector,
                propertyAgent,
                developerName,
            } = modalData;

            setValue("name", name);
            setValue("projectDirector", projectDirector ? {
                label: projectDirector.name,
                value: projectDirector._id
            } : undefined);
            setValue("salesDirector", salesDirector ? {
                label: salesDirector.name,
                value: salesDirector._id
            } : undefined);
            setValue("propertyAgent", propertyAgent ? {
                label: propertyAgent.name,
                value: propertyAgent._id
            } : undefined);
            setValue("developerName", developerName);
        }
    }, [editModalState, modalData, setValue]);

    const memberSelect = useMemo(
        () => ({
            control: (provided) => ({
                ...provided,
                borderColor: isDarkMode ? "#4B5563" : "#d1d5db",
                backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                borderRadius: "0.5rem",
                minHeight: "38px",
                boxShadow: "none",
                "&:hover": {
                    borderColor: "#3b82f6",
                },
            }),
            placeholder: (provided) => ({
                ...provided,
                color: isDarkMode ? "#9CA3AF" : "#6b7280",
                fontSize: "0.875rem",
            }),
            menu: (provided) => ({
                ...provided,
                backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                borderColor: isDarkMode ? "#4B5563" : "#e2e8f0",
            }),
            option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected
                    ? isDarkMode
                        ? "#1F2937"
                        : "#3B82F6"
                    : state.isFocused
                    ? isDarkMode
                        ? "#4B5563"
                        : "#F3F4F6"
                    : isDarkMode
                    ? "#374151"
                    : "#ffffff",
                color: state.isSelected
                    ? isDarkMode
                        ? "#D1D5DB"
                        : "#ffffff"
                    : isDarkMode
                    ? "#D1D5DB"
                    : "#1F2937",
            }),
            singleValue: (provided) => ({
                ...provided,
                color: isDarkMode ? "#D1D5DB" : "#1F2937",
            }),
            container: (provided) => ({
                ...provided,
                width: "100%",
            }),
        }),
        [isDarkMode]
    );

    const {
        data: projectsData,
        loading: projectsLoading,
        refetch: refetchProjects,
    } = useQuery(queries.FETCH_PROJECTS, {
        fetchPolicy: "network-only",
        variables: {
            limit: paginationState.limit,
            page: paginationState.page,
            dir: paginationState.dir,
            by: paginationState.by,
            name: appliedSearchVariables.name,
            projectDirector: appliedSearchVariables.projectDirector,
            salesDirector: appliedSearchVariables.salesDirector,
            propertyAgent: appliedSearchVariables.propertyAgent,
            status: appliedSearchVariables.status,
            project: appliedSearchVariables.project,
            developer: appliedSearchVariables.developer,
        },
        onError: ({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                for (const graphQLError of graphQLErrors) {
                    console.log(graphQLError);
                }
            }

            if (networkError) {
                console.log(networkError);
            }
        },
    });

    const columns = useMemo(() => {
            return [
                {
                    Header: "Name",
                    accessor: "name",
                    Cell: ({ row: { original } }) => {
                        return (
                            <div>{original.name}</div>
                        )
                    },
                },
                {
                    Header: "Developer",
                    accessor: "developerName",
                },
                {
                    Header: "Sales Director",
                    accessor: "salesDirector",
                    },
                {
                Header: "Project Director",
                accessor: "projectDirector",
                },
               
                {
                    Header: "Coordinator",
                    accessor: "propertyAgent",
                    },
                {
                Header: "Status",
                accessor: "status",
                },
                {
                    Header: "",
                    id: "actions",
                    Cell: ({ row: { original } }) => {
                        return (
                            <div className="flex items-center">
                                <div
                                    className="cursor-pointer mr-2"
                                    onClick={() => {
                                        setEditModalState(true);
                                        setModalData({
                                            ...original,
                                        });
                                    }}
                                >
                                    <FiEdit />
                                </div>
                                <div
                                    className="cursor-pointer mr-2"
                                    onClick={async () => {
                                        setModalData({
                                            ...original,
                                        });
                                    }}
                                >
                                    <FiUnlock />
                                </div>
                            </div>
                        );
                    },
                },
            ];
    }, [setModalData]);

    const resetCreateModal = () => {
        setCreateModalState(false);
        setModalData({});
        resetForm();
    };


    const resetEditModal = () => {
        setEditModalState(false);
        setModalData({});
        resetForm();
    };


    const [createProject] = useMutation(queries.CREATE_PROJECT);
    const [updateProject] = useMutation(queries.UPDATE_PROJECT);

    useEffect(() => {
        if (createModalState) {
            resetForm({
                name: "",
                projectDirector: undefined,
                salesDirector: undefined,
                propertyAgent: undefined,
            });
        }
    }, [createModalState, resetForm]);

    const loadSalesDirectors = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: userQueries.FETCH_USERS,
                    variables: {
                        name: val,
                        limit: 9999,
                        page: 1,
                        type: "sd",
                    },
                    fetchPolicy: "network-only",
                });

                callback([
                    { label: "None", value: undefined },
                    ...result.data.fetchUsers.data.map((item) => ({
                        label: `${item.name}`,
                        value: item._id,
                    }))
                ]);
            }, 500);
        },
        [apollo]
    );

    const loadActiveProjects = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: queries.FETCH_PROJECTS,
                    variables: {
                        name: val,
                        status: "active",
                        limit: 9999,
                        page: 1,
                    },
                    fetchPolicy: "network-only",
                });

                callback(
                    result.data.fetchProjects.data.map((item) => ({
                        label: `${item.name}`,
                        value: item._id,
                    }))
                );
            }, 500);
        },
        [apollo]
    );

    const loadPropertyAgents = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: userQueries.FETCH_USERS,
                    variables: {
                        name: val,
                        limit: 9999,
                        page: 1,
                        type: "agent",
                    },
                    fetchPolicy: "network-only",
                });

                callback([
                    { label: "None", value: undefined },
                    ...result.data.fetchUsers.data.map((item) => ({
                        label: `${item.name}`,
                        value: item._id,
                    }))
                ]);
            }, 500);
        },
        [apollo]
    );

    const loadProjectDirectors = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: userQueries.FETCH_USERS,
                    variables: {
                        name: val,
                        limit: 9999,
                        page: 1,
                        type: "pd",
                    },
                    fetchPolicy: "network-only",
                });

                callback([
                    { label: "None", value: undefined },
                    ...result.data.fetchUsers.data.map((item) => ({
                        label: `${item.name}`,
                        value: item._id,
                    }))
                ]);
            }, 500);
        },
        [apollo]
    );

    const handleCreateProject = async (formData) => {
        try {
            const result = await createProject({
                variables: {
                    input: {
                        name: formData.name,
                        projectDirector: formData.projectDirector?.value,
                        salesDirector: formData.salesDirector?.value,
                        propertyAgent: formData.propertyAgent?.value,
                        developerName: formData.developerName,
                    },
                },
            });

            if (result.data) {
                refetchProjects();
                setCreateModalState(false);
                resetForm();
                alert("Project created successfully");
            }
        } catch (err) {
            alert("Failed to create project");
            console.log(err);
        }
    };

    const handleEditProject = async (formData) => {
        try {
            const result = await updateProject({
                variables: {
                    input: {
                        _id: modalData._id,
                        name: formData.name,
                        projectDirector: formData.projectDirector?.value,
                        salesDirector: formData.salesDirector?.value,
                        propertyAgent: formData.propertyAgent?.value,
                        developerName: formData.developerName,
                    },
                },
            });

            if (result.data) {
                refetchProjects();
                setEditModalState(false);
                setModalData({});
                resetForm();
                alert("Project updated successfully");
            }
        } catch (err) {
            alert("Failed to update project");
            console.log(err);
        }
    };

    const [deleteProject] = useMutation(queries.DELETE_PROJECT);

    const handleDeleteProject = async (projectId) => {
        if (!window.confirm("Are you sure you want to delete this project?")) {
            return;
        }

        try {
            const result = await deleteProject({
                variables: {
                    input: {
                        _id: projectId,
                    },
                },
            });

            if (result.data) {
                refetchProjects();
                alert("Project deleted successfully");
            }

          
        } catch (err) {
            alert("Failed to delete project");
            console.log(err);
        }
    };


    return (
        <div
            className={`min-h-screen w-full max-w-full overflow-x-hidden ${
                isDarkMode ? "bg-gray-900" : "bg-gray-50"
            }`}
        >
            <div className="px-4 py-8 w-full min-w-0 max-w-full">
            <div className="flex justify-between items-center mb-6">
                <h1 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : ''}`}>Projects</h1>
                {user.type !== "agent" && (
                    <button
                        onClick={() => setCreateModalState(true)}
                        className={`flex items-center px-4 py-2 rounded text-white ${
                            isDarkMode
                                ? "bg-blue-600 hover:bg-blue-500"
                                : "bg-blue-500 hover:bg-blue-600"
                        }`}
                    >
                        <FiPlus className="mr-2" />
                        Add Project
                    </button>
                )}
            </div>

            <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white'} rounded-lg shadow p-4 mb-6 border`} key={formKey}>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Coordinator
                        </label>
                        <Controller
                            as={
                                <AsyncSelect
                                    styles={memberSelect}
                                    isSearchable={true}
                                    isClearable={true}
                                />
                            }
                            name="propertyAgent"
                            control={control}
                            rules={{ required: false }}
                            loadOptions={loadPropertyAgents}
                            onChange={([selected]) => {
                                setFilters(prev => ({
                                    ...prev,
                                    propertyAgent: selected?.value
                                }));
                            }}
                        />
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Sales Director
                        </label>
                        <Controller
                            as={
                                <AsyncSelect
                                    styles={memberSelect}
                                    isSearchable={true}
                                    isClearable={true}
                                />
                            }
                            name="salesDirector"
                            control={control}
                            rules={{ required: false }}
                            loadOptions={loadSalesDirectors}
                            onChange={([selected]) => {
                                setFilters(prev => ({
                                    ...prev,
                                    salesDirector: selected?.value
                                }));
                            }}
                        />
                    </div>
                    
                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Project Director
                        </label>
                        <Controller
                            as={
                                <AsyncSelect
                                    styles={memberSelect}
                                    isSearchable={true}
                                    isClearable={true}
                                />
                            }
                            name="projectDirector"
                            control={control}
                            rules={{ required: false }}
                            loadOptions={loadProjectDirectors}
                            onChange={([selected]) => {
                                setFilters(prev => ({
                                    ...prev,
                                    projectDirector: selected?.value
                                }));
                            }}
                        />
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Project Name
                        </label>
                        <Controller
                            as={
                                <AsyncSelect
                                    styles={memberSelect}
                                    isSearchable={true}
                                    isClearable={true}
                                />
                            }
                            name="project"
                            control={control}
                            rules={{ required: false }}
                            loadOptions={loadActiveProjects}
                            onChange={([selected]) => {
                                setFilters(prev => ({
                                    ...prev,
                                    project: selected
                                }));
                            }}
                        />
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Developer
                        </label>
                        <input
                            type="text"
                            className={`w-full py-2 px-3 rounded-lg border text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                                isDarkMode 
                                    ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                    : 'bg-white border-gray-300 text-gray-900'
                            }`}
                            placeholder="Search by developer name"
                            value={filters.developer || ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                setFilters(prev => ({
                                    ...prev,
                                    developer: value
                                }));
                            }}
                        />
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Status
                        </label>
                        <Controller
                            as={
                                <Select
                                    styles={memberSelect}
                                    isSearchable={false}
                                    placeholder="Select Status"
                                    isClearable={true}
                                />
                            }
                            name="status"
                            control={control}
                            options={statusOptions}
                            onChange={([selected]) => {
                                setFilters(prev => ({
                                    ...prev,
                                    status: selected?.value
                                }));
                            }}
                        />
                    </div>

                    <div className="flex h-full items-end gap-2">
                        <button
                            type="button"
                            onClick={handleSearch}
                            className={`px-4 py-2 min-h-[38px] rounded text-white ${
                                isDarkMode
                                    ? "bg-blue-600 hover:bg-blue-500"
                                    : "bg-blue-500 hover:bg-blue-600"
                            }`}
                        >
                            Search
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                setFilters(initialFilters);
                                setAppliedSearchVariables(
                                    initialAppliedSearchVariables
                                );
                                setDebouncedFilters({
                                    developer: "",
                                });
                                setPaginationState({
                                    limit: 30,
                                    page: 1,
                                    dir: "desc",
                                    by: "_id",
                                });
                                resetForm();
                                setFormKey(prev => prev + 1);
                            }}
                            className={`px-4 py-2 min-h-[38px] rounded text-white ${
                                isDarkMode
                                    ? "bg-gray-600 hover:bg-gray-500"
                                    : "bg-gray-500 hover:bg-gray-600"
                            }`}
                        >
                            Reset Filters
                        </button>
                    </div>
                </div>
            </div>

            <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white'} rounded-lg shadow border overflow-x-auto w-full min-w-0 max-w-full`}>
                {projectsLoading ? (
                    <div className="flex flex-col items-center justify-center py-24 px-4">
                        <div className="relative w-16 h-16 mb-4">
                            <div className="absolute inset-0 border-4 border-orange-200 rounded-full"></div>
                            <div className="absolute inset-0 border-4 border-orange-500 rounded-full border-t-transparent animate-spin"></div>
                        </div>
                        <p className={`font-medium ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                            Loading projects...
                        </p>
                        <p className={`text-sm mt-1 ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}>
                            Please wait
                        </p>
                    </div>
                ) : (
                <>
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="text-black">
                        <tr className="bg-orange-400">
                            {columns.map((column) => (
                                <th
                                    key={column.Header}
                                    className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider whitespace-nowrap"
                                >
                                    {column.Header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} divide-y divide-gray-200`}>
                        {projectsData?.fetchProjects?.data?.length > 0 ? projectsData.fetchProjects.data.map((project) => (
                            <tr key={project._id} className={`${isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                                <td className={`px-6 py-4 whitespace-nowrap text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{project.name}</td>
                                <td className={`px-6 py-4 whitespace-nowrap text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>
                                    {project.developerName ? capitalizeWords(project.developerName) : "None"}
                                </td>
                                <td className={`px-6 py-4 whitespace-nowrap text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>
                                    {project.salesDirector?.name ? capitalizeWords(project.salesDirector.name) : "None"}
                                </td>
                                <td className={`px-6 py-4 whitespace-nowrap text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>
                                    {project.projectDirector?.name ? capitalizeWords(project.projectDirector.name) : "None"}
                                </td>
                              
                                <td className={`px-6 py-4 whitespace-nowrap text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>
                                    {project.propertyAgent?.name ? capitalizeWords(project.propertyAgent.name) : "None"}
                                </td>
                               
                                {user.type !== "agent" && (
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="flex space-x-2">
                                            <button
                                                onClick={() => {
                                                    setModalData(project);
                                                    setEditModalState(true);
                                                }}
                                                className="text-orange-400 hover:text-orange-600"
                                            >
                                                <FiEdit2 />
                                            </button>
                                            {(user.auth?.type ?? user.type) !== "manager" && (
                                                <button
                                                    onClick={() => handleDeleteProject(project._id)}
                                                    className="text-orange-400 hover:text-orange-600"
                                                >
                                                    <FiTrash2 />
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                )}
                            </tr>
                        )) : (
                            <tr>
                                <td
                                    colSpan={4}
                                    className={`px-6 py-4 text-center ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}
                                >
                                    No projects found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                    {projectsData && projectsData.fetchProjects.pagination && (
                    <div className={`px-4 py-3 flex items-center justify-between border-t ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                        <div className="flex-1 flex justify-between items-center">
                            <div className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                Showing{' '}
                                <span className="font-medium">
                                    {((paginationState.page - 1) * paginationState.limit) + 1}
                                </span>
                                {' '}-{' '}
                                <span className="font-medium">
                                    {Math.min(paginationState.page * paginationState.limit, projectsData.fetchProjects.pagination.documents)}
                                </span>
                                {' '}of{' '}
                                <span className="font-medium">{projectsData.fetchProjects.pagination.documents}</span>
                                {' '}results
                            </div>
                            <div className="flex space-x-2">
                                <button
                                    onClick={() => {
                                        setPaginationState(prev => ({ ...prev, page: 1 }));
                                    }}
                                    disabled={paginationState.page === 1}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === 1
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    First
                                </button>
                                <button
                                    onClick={() => {
                                        setPaginationState(prev => ({ ...prev, page: prev.page - 1 }));
                                    }}
                                    disabled={paginationState.page === 1}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === 1
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Previous
                                </button>
                                <span className={`px-3 py-1 rounded-md text-sm font-medium ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-900'}`}>
                                    Page {paginationState.page} of {projectsData.fetchProjects.pagination.totalPages}
                                </span>
                                <button
                                    onClick={() => {
                                        setPaginationState(prev => ({ ...prev, page: prev.page + 1 }));
                                    }}
                                    disabled={paginationState.page === projectsData.fetchProjects.pagination.totalPages}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === projectsData.fetchProjects.pagination.totalPages
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Next
                                </button>
                                <button
                                    onClick={() => {
                                        setPaginationState(prev => ({ ...prev, page: projectsData.fetchProjects.pagination.totalPages }));
                                    }}
                                    disabled={paginationState.page === projectsData.fetchProjects.pagination.totalPages}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === projectsData.fetchProjects.pagination.totalPages
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Last
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                </>
                )}
            </div>

            {createModalState && (
                <Modal reset={resetCreateModal}>
                    <div className="container h-full mx-auto flex justify-center items-center">
                        <div className={`panel p-6 rounded-md max-w-5xl w-full ${isDarkMode ? 'bg-gray-800 text-white' : 'bg-white'}`}>
                            <div className={`mb-4 text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Create Project</div>
                            <form onSubmit={handleSubmit(handleCreateProject)}>
                                <div className="mb-4">
                                    <label className={`block text-sm font-bold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                        Project Name
                                    </label>
                                    <input
                                        className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                            isDarkMode 
                                                ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                                : 'bg-cool-gray border-gray-300 text-lynch'
                                        } ${
                                            errors.name
                                                ? "border-red-400" 
                                                : ""
                                        }`}
                                        name="name"
                                        ref={register({ required: true })}
                                        placeholder="Project Name"
                                        type="text"
                                        step=".01"
                                    />
                                    {errors.name && (
                                        <p className="text-red-500 text-xs italic">
                                            Project name is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <div className={`my-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                        Developer Name
                                    </div>
                                    <input
                                        type="text"
                                        className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                            isDarkMode 
                                                ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                                : 'bg-cool-gray border-gray-300 text-lynch'
                                        } ${
                                            errors.developerName
                                                ? "border-red-400" 
                                                : ""
                                        }`}
                                        name="developerName"
                                        ref={register({ required: true })}
                                        placeholder="Developer Name"
                                    />
                                    {errors.developerName && (
                                        <p className="text-red-500 text-xs italic">
                                            Developer name is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <div className={`my-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                        Sales Director
                                    </div>
                                    <Controller
                                        as={
                                            <AsyncSelect
                                                styles={memberSelect}
                                                isSearchable={true}
                                            />
                                        }
                                        name="salesDirector"
                                        control={control}
                                        rules={{ required: false }}
                                        loadOptions={loadSalesDirectors}
                                        className="mb-2"
                                    />
                                </div>

                                <div className="mb-4">
                                    <div className={`my-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                        Project Director
                                    </div>
                                    <Controller
                                        as={
                                            <AsyncSelect
                                                styles={memberSelect}
                                                isSearchable={true}
                                            />
                                        }
                                        name="projectDirector"
                                        control={control}
                                        rules={{ required: false }}
                                        loadOptions={loadProjectDirectors}
                                        className="mb-2"
                                    />
                                   
                                </div>

                               

                                <div className="mb-4">
                                    <div className={`my-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                        Coordinator
                                    </div>
                                    <Controller
                                        as={
                                            <AsyncSelect
                                                styles={memberSelect}
                                                isSearchable={true}
                                            />
                                        }
                                        name="propertyAgent"
                                        control={control}
                                        rules={{ required: false }}
                                        loadOptions={loadPropertyAgents}
                                        className="mb-2"
                                    />
                                </div>

                               

                                <button
                                    type="submit"
                                    className="bg-orange-400 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                >
                                    Create Project
                                </button>
                            </form>
                        </div>
                    </div>
                </Modal>
            )}

            {editModalState && (
                <Modal reset={resetEditModal}>
                    <div className="container h-full mx-auto flex justify-center items-center">
                        <div className={`panel p-6 rounded-md max-w-5xl w-full ${isDarkMode ? 'bg-gray-800 text-white' : 'bg-white'}`}>
                            <div className={`mb-4 text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Edit Project</div>
                            <form onSubmit={handleSubmit(handleEditProject)}>
                                <div className="mb-4">
                                    <label className={`block text-sm font-bold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                        Project Name
                                    </label>
                                    <input
                                        type="text"
                                        className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                            isDarkMode 
                                                ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                                : 'bg-cool-gray border-gray-300 text-lynch'
                                        } ${
                                            errors.name
                                                ? "border-red-400" 
                                                : ""
                                        }`}
                                        name="name"
                                        ref={register({ required: true })}
                                        placeholder="Project Name"
                                    />
                                    {errors.name && (
                                        <p className="text-red-500 text-xs italic">
                                            Project name is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <div className={`my-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                        Developer Name
                                    </div>
                                    <input
                                        type="text"
                                        className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                            isDarkMode 
                                                ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                                : 'bg-cool-gray border-gray-300 text-lynch'
                                        } ${
                                            errors.developerName
                                                ? "border-red-400" 
                                                : ""
                                        }`}
                                        name="developerName"
                                        ref={register({ required: false })}
                                        placeholder="Developer Name"
                                    />
                                    {errors.developerName && (
                                        <p className="text-red-500 text-xs italic">
                                            Developer name is required
                                        </p>
                                    )}
                                </div>  

                                <div className="mb-4">
                                    <div className={`my-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                        Sales Director
                                    </div>
                                    <Controller
                                        as={
                                            <AsyncSelect
                                                styles={memberSelect}
                                                isSearchable={true}
                                            />
                                        }
                                        name="salesDirector"
                                        control={control}
                                        rules={{ required: false }}
                                        loadOptions={loadSalesDirectors}
                                        className="mb-2"
                                    />
                                   
                                </div>

                                <div className="mb-4">
                                    <div className={`my-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                        Project Director
                                    </div>
                                    <Controller
                                        as={
                                            <AsyncSelect
                                                styles={memberSelect}
                                                isSearchable={true}
                                            />
                                        }
                                        name="projectDirector"
                                        control={control}
                                        rules={{ required: false }}
                                        loadOptions={loadProjectDirectors}
                                        className="mb-2"
                                    />
                                  
                                </div>

                               

                                <div className="mb-4">
                                    <div className={`my-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                        Coordinator
                                    </div>
                                    <Controller
                                        as={
                                            <AsyncSelect
                                                styles={memberSelect}
                                                isSearchable={true}
                                            />
                                        }
                                        name="propertyAgent"
                                        control={control}
                                        rules={{ required: false }}
                                        loadOptions={loadPropertyAgents}
                                        className="mb-2"
                                    />
                                    
                                </div>

                                <button
                                    type="submit"
                                    className="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                >
                                    Update Project
                                </button>
                            </form>
                        </div>
                    </div>
                </Modal>
            )}
            </div>
        </div>
    );
};

export default withUser(Projects);
